export default [
    {
        path: 'sala',
        component: () => import(
            /* webpackChunkName: 'cadastro-sala' */
            '@/views/cadastro/sala/Index'
        ),
        redirect: 'sala/index',
        children: [
            {
                name: 'cadastro-sala-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-sala' */
                    '@/views/cadastro/sala/List'
                ),
            },
            {
                name: 'cadastro-sala-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-sala' */
                    '@/views/cadastro/sala/Form'
                ),
            },
            {
                name: 'cadastro-sala-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-sala' */
                    '@/views/cadastro/sala/Form'
                ),
            },
        ],
    },
]